type BackendSettings = {
  available_languages: string[];
  fallback_language: string;
  domain_mapping: Record<string, string>;
};

export type Settings = {
  availableLanguages: string[];
  fallbackLanguage: string;
  domainMapping: Record<string, string>;
};

export const settingsMapper = (response: { data: BackendSettings }): Settings => ({
  availableLanguages: response.data.available_languages,
  fallbackLanguage: response.data.fallback_language,
  domainMapping: response.data.domain_mapping,
});
